import { Flex, Typography } from 'antd';
import { AuditEntityLink } from 'components/common/audit-logs/components/audit-entity-link';
import styles from './audit-log-change.module.scss';
import type { IAuditLogChangeProps } from './types.ts';

const { Text } = Typography;

export const AuditLogChange: React.FC<IAuditLogChangeProps> = (props) => {
  const { change } = props;

  return (
    <div className={styles.change}>
      <Text type='secondary'>{change.fieldName}</Text>
      {change.type === 'entities' ? (
        <Flex gap={4} wrap='wrap'>
          {change.references.map((reference, index) => (
            <span key={index}>
              <AuditEntityLink reference={reference} />
              {index < change.references.length - 1 ? ',' : null}
            </span>
          ))}
        </Flex>
      ) : (
        <Flex gap={4} wrap='wrap'>
          <Text>{change.oldValue}</Text>
          <Text>→</Text>
          <Text>{change.newValue}</Text>
        </Flex>
      )}
    </div>
  );
};
